import * as React from "react";
const LockFill = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M9,7 C9,5.346 10.346,4 12,4 C13.654,4 15,5.346 15,7 L15,10 L9,10 L9,7 Z M17.5,10 L16,10 L16,7 C16,4.794 14.206,3 12,3 C9.794,3 8,4.794 8,7 L8,10 L6.5,10 C5.673,10 5,10.673 5,11.5 L5,19.5 C5,20.327 5.673,21 6.5,21 L17.5,21 C18.327,21 19,20.327 19,19.5 L19,11.5 C19,10.673 18.327,10 17.5,10 L17.5,10 Z" }));
LockFill.displayName = "LockFill";
var LockFill_default = LockFill;
export {
  LockFill_default as default
};
